import React from "react";
import { IconButton, Avatar, Tooltip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import PersonIcon from "@mui/icons-material/Person";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import { CapSentence } from "../../utils/Utils";
import { Typography } from "@mui/joy";

export const columnsAuditoria = (
  handleNew,
  handleEdit,
  handleDelete,
  handleView,
  showExtraColumns = false
) => {
  const baseColumns = [
    {
      field: "index",
      headerName: "#",
      width: 0.2, // Ajusta el tamaño de la columna de índice
      renderCell: (params) => params.row.index, // Muestra el índice
    },
    { field: "fechaarg", headerName: "Fecha", flex: 1 },
    { field: "documento_paciente", headerName: "Documento", flex: 1 },
    { field: "codigo", headerName: "Código", flex: 0.8 },
    { field: "diente", headerName: "Pieza", flex: 0.3 },
    { field: "caras", headerName: "Caras", flex: 0.3 },
    {
      field: "resultado_auditoria",
      headerName: "Aud.",
      flex: 0.5,
      renderCell: (params) => {
        const auditResult = params.row.resultado_auditoria;
        let color = "#f5f5f5";

        if (["X", "O", "L"].includes(auditResult)) {
          color = "#4caf50";
        } else if (["F", "R", "A"].includes(auditResult)) {
          color = "#f44336";
        } else {
          color = "transparent";
        }

        if (params.row.auditando) {
          return (
            <AutorenewIcon
              sx={{
                ml: 0,
                color: "primary.main",
                animation: "spin 1s linear infinite",
                "@keyframes spin": {
                  "0%": { transform: "rotate(0deg)" },
                  "100%": { transform: "rotate(360deg)" },
                },
              }}
            />
          );
        }

        return (
          <Avatar
            sx={{
              backgroundColor: color,
              color: "white",
              fontSize: 14,
              width: 24,
              height: 24,
              fontWeight: "bold",
            }}
          >
            {auditResult ? auditResult[0] : ""}
          </Avatar>
        );
      },
    },
    { field: "debitos", headerName: "Débitos", flex: 0.6 },
    {
      field: "valor",
      headerName: "Valor",
      flex: 1,
      align: "right",
      headerAlign: "right",
    },
  ];

  const extraColumns = [
    { field: "tratamiento_id", headerName: "id", flex: 0.5 },
    { field: "especialidad", headerName: "Especialidad", flex: 1 },
    {
      field: "nombre_paciente",
      headerName: "Paciente",
      flex: 2,
      valueFormatter: (params) =>
        CapSentence(params.value?.toLowerCase() ?? ""),
    },
    { field: "edad_paciente", headerName: "Edad", flex: 0.5 },
    { field: "codigo_empresa", headerName: "Cliente", flex: 0.5 },
  ];

  const actions = {
    field: "actions",
    headerName: "Acciones",
    flex: 1.7,
    sortable: false,
    filterable: false,
    disableColumnMenu: true,
    renderCell: (params) => (
      <>
        <Tooltip title="Insertar prestación">
          <IconButton color="primary" size="small" onClick={() => handleNew()}>
            <AddIcon sx={{ fontSize: 30 }} />
          </IconButton>
        </Tooltip>
        <Tooltip title="Modificar prestación">
          <IconButton
            color="primary"
            size="small"
            onClick={() => handleEdit(params.row)}
          >
            <EditIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Tooltip title="Borrar prestación">
          <IconButton
            color="error"
            size="small"
            onClick={() => handleDelete(params.row)}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Tooltip title="Ver paciente">
          <IconButton onClick={() => handleView(params.row)}>
            <PersonIcon fontSize="medium" color="primary" />
          </IconButton>
        </Tooltip>
      </>
    ),
  };

  return showExtraColumns
    ? [...extraColumns, ...baseColumns, actions]
    : [...baseColumns, actions];
};
